export default "<app-all-profile></app-all-profile>"